// DevHub: attributes that turn OFF the browser's native "saved info" on a search/filter input —
// form history (the dropdown of previously-typed values) and password-manager autofill overlays.
//
// Why we want this on search bars specifically:
//   • Every search bar renders its OWN results dropdown; the browser's native suggestion list
//     overlaps it and reads as broken UI.
//   • Form history persists every typed query in the local browser PROFILE, keyed by the field — so
//     on a shared/kiosk machine the next person sees prior colleagues' queries (which can name
//     internal tools/projects). Not a server-side risk, but a real privacy leak we don't need.
//
// Spread onto any native <input>; pass to Backstage's <SearchBar> via `inputProps`.
export const noBrowserAutofill = {
  autoComplete: 'off',
  autoCorrect: 'off', // Safari/iOS
  autoCapitalize: 'off', // mobile
  spellCheck: false, // no red squiggles under tool/component names
  'data-1p-ignore': true, // 1Password
  'data-lpignore': 'true', // LastPass
  'data-form-type': 'other', // Dashlane and others
} as const;
